/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import axios from "axios";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import { CookieSetting } from "cookiesetting-component";
import Logo from "./components/Logo Section/Logo";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import MediaQuery from "react-responsive";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import { useHyperlink } from "./contexts/HyperlinkProvider";

const Footer = lazy(() => import("./components/FooterNew/index.js"));
const ThankYou = lazy(() => import("./components/ThankYou/Thankyou.js"));
const PostEventMemories = lazy(() =>
  import("./components/PostEventMemories/PostEventMemories.js")
);
const PostSocial = lazy(() => import("./components/PostSocial/PostSocial.js"));
const ExploreSection = lazy(() =>
  import("./components/VideoSection/ExploreSection.js")
);
const ExploreMobile = lazy(() =>
  import("./components/VideoSection/ExploreMobile.js")
);

const Interior = lazy(() => import("./components/Interior/Interior.js"));

const SubscribeNotification = lazy(() =>
  import("./components/SubscribeNotification/SubscribeForEventNotifications.js")
);
const Combinedcarousel = lazy(() =>
  import("./components/CombinedCarousel/Combined.js")
);

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const isProduction = process.env.NODE_ENV === "production";
  const appVersion = appversion.version;

  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink1, setSunWestLink1] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const swLink1 = await getHyperLink("websites", "swmc", 0);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setSunWestLink1(swLink1 || 'Sun West');
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  // console.log(appVersion);
  // console.log(process.env.NODE_ENV);
  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      <div className="bodyContainer">
        <Header fetchpriority="high" />

        <>
          <Body fetchpriority="high" />
          <Suspense fallback={<div />}>
            <Interior links={links} angelAiLink={angelAiLink} pavanLink={pavanLink} celligenceLlcLink={celligenceLlcLink} sunwestLink={sunwestLink} />
          </Suspense>
          <Logo />
          {/* <Suspense fallback={<div />}>
            <ExploreSection />
          </Suspense>
          <Suspense fallback={<div />}>
            <ExploreMobile />
          </Suspense> */}

          {/* <Suspense fallback={<div />}>
            <PostEventMemories />
          </Suspense> */}

          <Suspense fallback={<div />}>
            <ThankYou links={links} angelAiLink={angelAiLink} pavanLink={pavanLink} celligenceLlcLink={celligenceLlcLink} sunwestLink={sunwestLink} sunwestLink1={sunwestLink1}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <SubscribeNotification />
          </Suspense>

          <Suspense fallback={<div />}>
            <Combinedcarousel links={links} angelAiLink={angelAiLink} sunwestLink={sunwestLink} celligenceLlcLink={celligenceLlcLink} />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </>
      </div>
    </CacheBuster>
  );
}

export default App;
